var exports = {
  "kL": "ProfileFollowActions.module__container___Qkw4TV",
  "gb": "ProfileFollowActions.module__iconButton___Qkw4TV",
  "Z": "ProfileFollowActions.module__countsButton___Qkw4TV",
  "Kk": "ProfileFollowActions.module__icon___Qkw4TV",
  "Wm": "ProfileFollowActions.module__followHoverLabel___Qkw4TV",
  "c7": "ProfileFollowActions.module__followingButton___Qkw4TV",
  "Ib": "ProfileFollowActions.module__followIdleLabel___Qkw4TV",
};

module.exports = exports;
